import { v4 as uuidv4 } from 'uuid';
import { mobileModel, mobileVendor, browserVersion, browserName } from 'mobile-device-detect';
import debounce from 'lodash/debounce';
import has from 'lodash/has';
import get from 'lodash/get';
import { getURLParams } from 'utils';
export const getDeviceId = () => {
  if (!localStorage || !localStorage.getItem) {
    return null;
  }
  if (!localStorage.getItem('d_id')) {
    localStorage.setItem('d_id', uuidv4());
  }
  return localStorage.getItem('d_id');
};

export const isTouchFriendly =
  navigator.userAgent.toLowerCase().indexOf('android') !== -1 ||
  navigator.userAgent.toLowerCase().indexOf('iphone') !== -1 ||
  navigator.userAgent.toLowerCase().indexOf('ipad') !== -1 ||
  navigator.userAgent.toLowerCase().indexOf('react-native') !== -1;

export const getOSName = () => {
  if (!navigator) {
    return null;
  } else return navigator.appVersion;
};

export const getBrowserProperties = () => {
  if (!navigator) {
    return null;
  } else {
    return {
      vendor: navigator.vendor,
      appCodeName: navigator.appCodeName,
      appName: navigator.appName,
      appVersion: navigator.appVersion,
      cookieEnabled: navigator.cookieEnabled,
      language: navigator.language,
      online: navigator.onLine,
      platform: navigator.platform,
      userAgent: navigator.userAgent,
    };
  }
};

export const prepareRegisterPayload = (userId = '', token = '', location = {}) => {
  let deviceInfo = {
    device_Id: getDeviceId(),
    UID: '',
    manufacturer: mobileVendor,
    model: mobileModel,
    os: 'web',
    browserVersion: browserVersion,
    browserName: browserName,
    devicename: getOSName(),
    deviceversion: '',
    bundleid: '',
    buildnumber: '',
    appname: 'ASSESSMENT',
    appversion: '',
    updatedby: '',
    notification_token: token,
  };
  const { lat = '', lng = '' } = location || {};
  if (lat || lng) {
    deviceInfo.location = { coordinates: [lng, lat] };
  }
  if (userId) {
    deviceInfo['user'] = userId;
  }
  return deviceInfo;
};

export const getCaseIdFromSession = () => {
  const caseId = sessionStorage.getItem('c_id');
  if (caseId) {
    return caseId;
  }
  return '';
};

export const checkIfProdEnv = () => {
  const { host } = window.location;
  if (host === 'apps.mfine.co' || host === 'www.mfine.co') {
    return true;
  }
  return false;
};

export const ESCAPE_KEY = 27;
export const UP_ARROW = 38;
export const DOWN_ARROW = 40;
export const LEFT_ARROW = 37;
export const RIGHT_ARROW = 39;

export const setPageTitle = (title = 'MFine Self Assessments') => {
  try {
    document.title = title;
  } catch (error) {
    console.error('Error in setting page title ::', error);
  }
};

export const normalizeFonts = debounce(
  () => {
    let normalizationFactor = 1;
    if (!isTouchFriendly) {
      normalizationFactor = window.innerWidth / 1680;
    } else {
      normalizationFactor = window.innerWidth / 411;
    }
    let normalizedBaseSize = Math.round(16 * normalizationFactor);
    normalizedBaseSize = normalizedBaseSize >= 14 ? normalizedBaseSize : 14;
    normalizedBaseSize = normalizedBaseSize <= 16 ? normalizedBaseSize : 16;
    document.body.style.fontSize = `${normalizedBaseSize}px`;
  },
  500,
  { leading: false, trailing: true }
);

export const isIOS =
  navigator.userAgent.toLowerCase().indexOf('iphone') !== -1 ||
  navigator.userAgent.toLowerCase().indexOf('ipad') !== -1;

export const isReactNative = navigator.userAgent.toLowerCase().indexOf('react-native') !== -1;

export const getChannel = () => {
  const params = getURLParams();
  const channel = has(params, 'channel');
  if (channel) return get(params, 'channel');
  else return '';
};

export const checkIfPAApp = () => {
  const currentChannel = getChannel();
  return ['pa', 'pn'].includes(currentChannel) && isReactNative;
};

export const postNativeMessage = event => {
  if (isReactNative) {
    window.ReactNativeWebView.postMessage(JSON.stringify(event));
  }
};

export const openInNewTab = url => {
  try {
    let event = { type: 'REDIRECT_TO', payload: url };
    postNativeMessage(event);
    const win = window.open(url, '_blank');
    win.focus();
  } catch (error) {
    console.error('Error in opening url in new tab ::', error);
  }
};

export const openInNewTabOnAllBrowsers = (url, win) => {
  try {
    let event = { type: 'REDIRECT_TO', payload: url };
    postNativeMessage(event);
    win.location = url;
    win.target = '_blank';
    win.focus();
  } catch (error) {
    console.error('Error in opening url in new tab ::', error);
  }
};

export const openInNewTabUsingHiddenAnchorTag = url => {
  try {
    const element = document.getElementById('open-in-new-tab');
    element.setAttribute('href', url);
    element.click();
  } catch (error) {
    console.error('Error in opening url in new tab UsingHiddenAnchorTag::', error);
  }
};
